import { useCallback, useEffect, useState } from 'react';
import { getPlayerCards, removePeachToken, } from '@digiwedge/teetime-api-client';
const normaliseError = (err) => err instanceof Error ? err : new Error(String(err ?? 'Unknown error fetching cards'));
export const usePlayerCards = ({ email, clubCode }) => {
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchCards = useCallback(async () => {
        if (!email) {
            setCards([]);
            setError(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await getPlayerCards(email, clubCode);
            setCards(response.PlayerTokensList ?? []);
        }
        catch (err) {
            setError(normaliseError(err));
            setCards([]);
        }
        finally {
            setLoading(false);
        }
    }, [clubCode, email]);
    useEffect(() => {
        void fetchCards();
    }, [fetchCards]);
    const refetch = () => {
        void fetchCards();
    };
    const baseReturn = {
        cards,
        loading,
        error,
        refetch,
    };
    const removeCard = useCallback(async (params) => {
        setLoading(true);
        setError(null);
        try {
            const response = await removePeachToken(params);
            setCards(response.PlayerTokensList ?? []);
            return response;
        }
        catch (err) {
            const normalized = normaliseError(err);
            setError(normalized);
            throw normalized;
        }
        finally {
            setLoading(false);
        }
    }, []);
    return {
        ...baseReturn,
        removeCard,
    };
};
//# sourceMappingURL=usePlayerCards.js.map